import styled from 'styled-components';

export const Container = styled.div`
  .MuiTextField-root {
    width: 100%;
    margin-top: 16px;
  }
  input {
    color: black;
    background: white;
  }
`;

export const InputPadrao = styled.input`
  font-size: 16px;
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  padding-top: 5px;
  margin-top: 10px;
`;
